/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: gavin chan
 * @Date: 2020-05-27 17:33:18
 * @LastEditors: gavin chan
 * @LastEditTime: 2020-09-16 09:51:42
 * @Notes:
 */
const {
  REACT_APP_WORKBENCH_API_URL,
  REACT_APP_RESOURCES_API_URL,
} = process.env;
export const RESOURCES_API_URL = REACT_APP_RESOURCES_API_URL;
export const WORKBENCH_API_URL = REACT_APP_WORKBENCH_API_URL;
export const ORDER_ICONS =
  "https://at.alicdn.com/t/font_1224826_83n39zldsmo.js";
